import {useDateTimeFormatter} from 'platform/locale';

import {useMemo} from 'react';

import {useGetVehicleAuditApiCatalogsQuery} from '@dms/api/core';

import {getPopoverHeaderData} from '../utils/getPopoverHeaderData';

export const useHeaderPopoverData = (inspectionId?: string) => {
  const formatDateTime = useDateTimeFormatter();
  const {data, refetch} = useGetVehicleAuditApiCatalogsQuery(
    {
      auditId: inspectionId ?? '',
    },
    {
      skip: !inspectionId,
    }
  );

  // eslint-disable-next-line react/exhaustive-deps -- Muted pre-existing violation
  const popoverHeaderData = useMemo(() => getPopoverHeaderData(formatDateTime, data), [data]);
  if (!data) {
    return null;
  }
  return {popoverHeaderData, refetchData: refetch};
};
